/**
 * 自定义供应商类型，用于渲染和字段校验
 */
export enum customSupplierTypeEnum {
  "服装_成衣_FGP/VMI" = 1,
  "服装_成衣_OEM" = 2,
  "服装_成衣_ODM" = 3,
  "服装_成衣_IPD" = 4,
  "服装_面辅料" = 5,
  "非服装_FGP/VMI" = 6,
  "非服装_IPD/OEM/ODM" = 7,
}
